import React from "react";
import "./cardrumah.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBed,
  faHouse,
  faMaximize,
  faShower,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const cardrumah = ({
  carousel,
  title,
  subtitle,
  price,
  details,
  whatsappLink,
  subprice,
}) => {
  const settings = {
    dots: carousel.length > 1,
    arrows: carousel.length > 1,
    infinite: carousel.length > 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: true,
  };

  return (
    <div className="cardrumahdetail">
      <div className="cluster-card">
        <Slider {...settings}>
          {carousel.map((image, index) => (
            <img
              className="cluster-image"
              key={index}
              src={image}
              alt={`Launching ${index + 1}`}
            />
          ))}
        </Slider>
        <div className="cluster-card-title">
          <div className="cluster-name">
            <div className="cluster-name-sub">{title}</div>
            <div className="cluster-name-sub2">{subtitle}</div>
          </div>
          <div className="cluster-price">
            <div className="cluster-price-sub">{price}</div>
            <div className="cluster-price-sub2">{subprice}</div>
          </div>
        </div>
        <hr className="card-separator" />
        <div className="gridspek">
          <FontAwesomeIcon icon={faMaximize} />
          <span>&nbsp;: {details.area}&nbsp;&nbsp;</span>
          <FontAwesomeIcon icon={faHouse} />
          <span>&nbsp;: {details.buildingSize}&nbsp;&nbsp;</span>
          <FontAwesomeIcon icon={faBed} />
          <span>&nbsp;: {details.bedrooms}&nbsp;&nbsp;</span>
          <FontAwesomeIcon icon={faShower} />
          <span>&nbsp;: {details.bathrooms}&nbsp;&nbsp;</span>
        </div>
        <div className="cluster-button">
          <button
            onClick={() => window.open(whatsappLink, "_blank")}
            className="cluster-whatsapp"
          >
            <FontAwesomeIcon size="lg" icon={faWhatsapp} />
            &nbsp;Whatsapp
          </button>
        </div>
      </div>
    </div>
  );
};

export default cardrumah;
